<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick" v-if="level !== 'STORE'">
      <el-tab-pane label="绑定设备充值订单" name="0"></el-tab-pane>
      <el-tab-pane label="区域设备充值订单" name="1" v-if="level === 'AREA'"></el-tab-pane>
    </el-tabs>
    <!-- <com-recharge-search @search="handleSearch" /> -->
    <!-- <com-recharge-list typeOfView="partner" :require-api="api" ref="table" :user-code="code" /> -->
    <com-search :columns="searchColumn" @search="handleSearch"></com-search>
    <com-table ref="table" :defaultParams="{ code }" :columns="columns" :api="api">
      <template #createTime="row">
        {{ row.data.createTime | timeFormate }}
      </template>
    </com-table>
  </div>
</template>

<script>
import { partnerRechargeOrder } from '@/api/partners'

export default {
  props: {
    code: {
      type: String,
      default: ''
    },
    level: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // defaultParams: {},
      activeName: '0',
      api: partnerRechargeOrder,
      columns: [
        {
          label: '订单编号',
          prop: 'number',
          width: 170
        },
        {
          label: '流水号',
          prop: 'transactionId',
          width: 280
        },
        {
          label: '用户ID',
          prop: 'userNum',
          minWidth: 120
        },
        {
          label: '手机号',
          prop: 'phone',
          minWidth: 120
        },
        {
          label: '充值金额',
          prop: 'paySum'
        },
        {
          label: '充值方式',
          prop: 'type'
        },
        {
          label: '充值时间',
          prop: 'createTime',
          type: 'slot',
          slotName: 'createTime',
          width: '180'
        }
      ],
      searchColumn: [
        {
          label: '用户ID/手机号',
          prop: 'number',
          type: 'input'
        },
        {
          label: '订单编号',
          prop: 'orderNum',
          type: 'input'
        },
        {
          label: '充值时间',
          prop: 'date',
          type: 'date'
        }
      ]
    }
  },
  methods: {
    handleClick() {
      // if (this.activeName === '1') {
      //   this.defaultParams.areaPartnerCode = this.code
      //   delete this.defaultParams.partnerCode
      //   this.$refs.table.init()
      //   return
      // }

      // this.defaultParams.partnerCode = this.code
      // delete this.defaultParams.areaPartnerCode
      this.$refs.table.init()
    },
    handleSearch(val) {
      this.$refs.table.search(val)
    }
  }
}
</script>

<style lang="scss" scoped></style>
